module.exports = __webpack_public_path__ + "img/payment-success.10294b5b.png";